import React from 'react';
import useDialog from '../hooks/useDialog';
import LoginForm from './LoginForm';

// Shown only when a session expires mid-edit. Signing back in here keeps you on
// the page with your work intact, rather than bouncing you to /admin.
function LoginModal({ onLogin, onClose, error }) {
  const dialogRef = useDialog(onClose);

  return (
    <div className="fixed inset-0 modal-overlay flex items-center justify-center p-4" style={{ zIndex: 50 }} onClick={onClose}>
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="login-modal-title"
        tabIndex={-1}
        className="bg-white rounded-xl p-8 max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="login-modal-title" className="text-3xl font-bold text-wine mb-6 text-center">
          Sign back in
        </h3>
        <LoginForm onSubmit={onLogin} error={error} onCancel={onClose} />
      </div>
    </div>
  );
}

export default LoginModal;
